<template>
  <div class="pb-2" :class="padding">
    <div class="flex flex-row items-center gap-x-1 rounded-[3px] border border-grey-400 p-2">
      <gv-icon name="search" size="md" class="fill-grey-400" aria-hidden="true" />
      <input
        v-model="search"
        :aria-label="placeholder"
        type="text"
        class="w-full border-0 bg-transparent p-0 focus:outline-none focus:ring-0"
        :placeholder="placeholder"
        :aria-placeholder="placeholder"
      />
      <button
        v-if="search"
        class="flex flex-row items-center"
        title="Clear search"
        aria-label="Clear search"
        @click.stop="() => (search = '')"
      >
        <gv-icon name="cancel_fill" size="xs" aria-hidden="true" fill />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  placeholder: string;
  padding: string;
  initialSearch?: string;
}>();

const search = ref<string>(props.initialSearch ?? '');

const emit = defineEmits<{
  (event: 'update:search', value: string): void;
}>();

watch(search, (value) => {
  emit('update:search', value ?? '');
});
</script>
